module.exports = __webpack_public_path__ + "img/1.f326f52c.jpeg";